import React, { Component, ChangeEvent } from "react";
import DialogTextInputViewProps from "./DialogTextInputViewProps";
import { TextField, FormControl } from "@material-ui/core";
import InputMask from 'react-input-mask';
import TranslationView from "../../../../../../components/Translation/TranslationView";
import DialogMultilineTextInputViewStyle from "../DialogMultilineTextInput/DialogMultilineTextInputViewStyle";

export default class DialogTextInputView extends Component<DialogTextInputViewProps> {

    private _style = new DialogMultilineTextInputViewStyle();

    render() {
        const { style, placeholder, error, mask, maskChar } = this.props;

        return (
            <FormControl style={{ ...this._style.textField, ...style }} error={error !== undefined}>

                    {mask ? 
                        (
                            <InputMask onChange={this.onChange} value={this.props.value} mask={mask} maskChar={maskChar}>
                                { 
                                    () => (
                                        <TextField
                                            label={placeholder && TranslationView.translate(placeholder)}
                                            error={!!error}
                                            helperText={error ? TranslationView.translate(error) : " "}
                                        />
                                    )
                                }
                            </InputMask>
                        )
                        :
                        (
                            <TextField
                                value={this.props.value}
                                label={placeholder && TranslationView.translate(placeholder)}
                                onChange={this.onChange}
                                error={!!error}
                                helperText={error ? TranslationView.translate(error) : " "} 
                            />
                        )
                    }
            </FormControl>
        );
    }

    onChange = (e : ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        this.props.onChange && this.props.onChange(e.target.value);
    }
}